import { AppDataConfig } from '@/types';

/**
 * Here you can define the app data that will be merged with the default app data. This allows you to customize the app data for
 * specific optimizely test. This appData would be merged if you set window.optimizelyTestScenario to this file name without the extension.
 * You should set window.optimizelyTestScenario in optimizely when you create the test. This merge operation will be checked and executed on initial mount only.
 * Please pay attention on merge rules:
 * - primitives and arrays will be overwritten
 * - objects will be merged recursively
 */
const appData = {} satisfies Partial<AppDataConfig> as Partial<AppDataConfig>;

export default appData;
